
<template>
    <vx-card class="limited-max-width" id="fifth-step">
        <div>
            <header-step-process-component
                v-bind:step="step"
            >
            </header-step-process-component>

            <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Cuestionario</span> <br /><br />
            <div class="subtitle-style-two">
                <span >La aseguradora necesita que contestes unas breves preguntas para poder emitir tu seguro.</span><br /><br />
            </div>
            <forms-repository
                v-bind:code="code"
                v-bind:next="next"
                v-bind:previus="previus"

                v-bind:formFilter="formFilter"
                >
            </forms-repository>
        </div>

    </vx-card>

</template>
<script>
import VxCard from '../../components/vx-card/VxCard.vue'
// import CallServicePopup from '../components/eprevision-components/callServicePopup/CallServicePopup.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue'
import FormsRepository from '../forms/e-prevision-forms/forms-repository.vue'
/* eslint-disable */ 
export default {
  components: { 
      VxCard, 
      HeaderStepProcessComponent, 
    //   CallServicePopup,
      FormsRepository },
   data() {
      return {
            step: 5,
            code: this.$route.params.code,
            dataStored: null,

            next: "extra-products/fifth",
            previus: "extra-products/third",
            formFilter: "civilLiabilityHealthQuestionnaireForm",
            commercialOffer: null

      }
  },
  created() {

        this.$vs.loading.close()
  },
  methods: {
     
  }
}
</script>
<style lang="scss">
// #fifth-step {
//     .questionnaire-buttons{
//         div{
//             margin-top:20px;
//             margin-bottom:40px;
//         }
//     }


//     #buttons .box-buttons .next-button{
//         display: none !important;
//     }

//     #buttons .box-buttons .call-button button{
//         margin-bottom: 10px !important;
//     }

// }


// @media only screen and (max-width: 400px) {
// }

// @media screen and (max-width: 497px) and  (min-width: 400px) {
// }


// @media (min-width: 601px) {
//     #fifth-step {
//         #buttons .box-buttons .call-button button{
//             float: right;
//         }
//     }

// }


</style>